/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Months_DecemberInputs */

const es_months_december = /** @type {(inputs: Months_DecemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diciembre`)
};

const en_months_december = /** @type {(inputs: Months_DecemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`December`)
};

/**
* | output |
* | --- |
* | "December" |
*
* @param {Months_DecemberInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const months_december = /** @type {((inputs?: Months_DecemberInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Months_DecemberInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_months_december(inputs)
	return en_months_december(inputs)
});
export { months_december as "months.december" }